import { ThemeEvents } from '@theme/events';

/** @type {string} */
const HEADER_CART_LINK_SELECTOR = 'header-actions a.action__cart[href*="/cart"]';

/**
 * @typedef {object} RebuySmartCart
 * @property {string} [status]
 * @property {() => void} [show]
 */

/**
 * @typedef {object} RebuyCart
 * @property {(callback?: () => void) => void} [fetchShopifyCart]
 */

/**
 * @returns {RebuySmartCart | undefined}
 */
function getSmartCart() {
  return /** @type {any} */ (window).Rebuy?.SmartCart;
}

/**
 * @returns {boolean}
 */
function showSmartCart() {
  const smartCart = getSmartCart();
  if (smartCart?.status === 'ready' && typeof smartCart.show === 'function') {
    smartCart.show();
    return true;
  }
  return false;
}

/**
 * @param {() => void} callback
 */
function whenSmartCartReady(callback) {
  if (showSmartCart()) return;

  document.addEventListener('rebuy:smartcart.ready', callback, { once: true });
}

/**
 * Sync Rebuy's cart mirror after Horizon AJAX cart changes.
 */
function syncRebuyCart() {
  /** @type {RebuyCart | undefined} */
  const cart = /** @type {any} */ (window).Rebuy?.Cart;
  cart?.fetchShopifyCart?.();
}

/**
 * Horizon dispatches cart:update instead of opening a drawer when cart_type is page.
 */
function bindHorizonCartEvents() {
  document.addEventListener(ThemeEvents.cartUpdate, (event) => {
    const { detail } = /** @type {CustomEvent<{ data?: { didError?: boolean } }>} */ (event);
    if (detail?.data?.didError) return;

    syncRebuyCart();
    whenSmartCartReady(() => showSmartCart());
  });
}

/**
 * @param {HTMLAnchorElement} link
 */
function bindCartLink(link) {
  link.addEventListener('click', (event) => {
    if (!getSmartCart()) return;

    event.preventDefault();
    whenSmartCartReady(() => showSmartCart());
  });
}

function bindCartTriggers() {
  document.querySelectorAll(HEADER_CART_LINK_SELECTOR).forEach((element) => {
    if (element instanceof HTMLAnchorElement) {
      bindCartLink(element);
    }
  });
}

function init() {
  bindCartTriggers();
  bindHorizonCartEvents();
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', init);
} else {
  init();
}

document.addEventListener('rebuy:smartcart.ready', bindCartTriggers);
